<template>
  <a-modal
    v-model="modal"
    title="批量修改叫料期望交货日期"
    width="500px"
    :maskClosable="false"
    :closable="false"
  >
    <a-form-model ref="form" :model="formData" :rules="rules">
      <a-form-model-item label="叫料期望交货日期" prop="date">
        <a-date-picker
          v-model="formData.date"
          style="width: 100%"
          :allowClear="false"
          valueFormat="YYYY-MM-DD 00:00:00"
          :disabledDate="disabledDate"
        />
      </a-form-model-item>
    </a-form-model>

    <template #footer>
      <a-space>
        <a-button @click="handleCancel">取消</a-button>
        <a-button type="primary" @click="handleConfirm">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'BatchEditCallExpectedDeliveryDateModal',
  data() {
    return {
      modal: false,
      formData: {
        date: undefined
      },
      rules: {
        date: [
          { required: true, message: '请选择叫料期望交货日期', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    show() {
      this.formData.date = undefined
      this.modal = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    disabledDate(current) {
      return current && current < this.$moment().startOf('day')
    },
    handleConfirm() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.$emit('confirm', this.formData.date)
        this.modal = false
      })
    },
    handleCancel() {
      this.modal = false
      this.$refs.form && this.$refs.form.resetFields()
    }
  }
}
</script>
